module.exports = __webpack_public_path__ + "static/footerSquiggle-c9e3996f217a849404b1e837e464f305.png";